export type EmailProvider = 'gmail' | 'outlook' | 'yahoo' | 'default';

export interface EmailComposePayload {
  subject?: string;
  body?: string;
  to?: string;
}

export const EMAIL_PROVIDERS: EmailProvider[] = [
  'default',
  'gmail',
  'outlook',
  'yahoo',
];

export const PROVIDER_LABEL_KEYS: Record<EmailProvider, string> = {
  default: 'emailCompose.defaultMail',
  gmail: 'emailCompose.gmail',
  outlook: 'emailCompose.outlook',
  yahoo: 'emailCompose.yahoo',
};

export function buildComposeUrl(
  provider: EmailProvider,
  { subject = '', body = '', to = '' }: EmailComposePayload
): string {
  const s = encodeURIComponent(subject);
  const b = encodeURIComponent(body);
  const t = encodeURIComponent(to);

  switch (provider) {
    case 'gmail':
      return `https://mail.google.com/mail/?view=cm&fs=1&to=${t}&su=${s}&body=${b}`;
    case 'outlook':
      return `https://outlook.office.com/mail/deeplink/compose?to=${t}&subject=${s}&body=${b}`;
    case 'yahoo':
      return `https://compose.mail.yahoo.com/?to=${t}&subject=${s}&body=${b}`;
    case 'default':
    default:
      return `mailto:${t}?subject=${s}&body=${b}`;
  }
}
